import { Mesh } from "three";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import model from "../../../../../assets/models/team2/SubTopic3/tooltipTapas.glb";
import { GUI } from "dat.gui";
import { gsap } from "gsap";
import ObserverEmitter, { EVENTS } from "../../../../../emitter/Observer";

export class TooltipLimpiezaTwo extends Mesh {
	constructor(camera, loadingManager) {
		super();
		let loader = new GLTFLoader(loadingManager);
		let dracoloader = new DRACOLoader();
		this.camera = camera;
		dracoloader.setDecoderPath("https://www.gstatic.com/draco/versioned/decoders/1.5.5/");
		this.loading = loader;
		loader.setDRACOLoader(dracoloader);
		this.onLoadModel(loader);
		this.scale.set(1, 1, 1);
		this.observerListtneners();
		// this.helpers();
	}

	onLoadModel(loader) {
		loader.load(model, (gltf) => {
			// gltf.scene.visible = false;
			this.add(gltf.scene);
			this.agitadores = gltf.scene.getObjectByName("agitadores", true);
			this.vasostooltip = gltf.scene.getObjectByName("vasostooltip", true);
			this.tapasextras = gltf.scene.getObjectByName("tapasextras", true);
			this.tapas = gltf.scene.getObjectByName("tapas", true);
			this.portamangas = gltf.scene.getObjectByName("portamangas", true);
		});
	}

	onvisibleObjects() {
		this.agitadores.visible = false;
		this.vasostooltip.visible = false;
		this.tapasextras.visible = false;
		this.tapas.visible = false;
		this.portamangas.visible = false;
		// this.helpersChild();
	}

	onEliminateScene() {
		if (this.animation) {
			this.animation.kill();
		}
		this.visible = false;
	}

	onActiveAgitador() {
		this.agitadores.position.set(-0.4118, 0, 0.4704);
		this.agitadores.visible = true;
	}

	observerListtneners() {
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.vasostooltip, () => {
			this.agitadores.visible = false;
			this.vasostooltip.position.set(0.4704, -0.4118, 0.4704);
			this.vasostooltip.rotation.y = -0.5441;
			this.vasostooltip.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.tapasextras, () => {
			this.vasostooltip.visible = false;
			this.tapasextras.position.set(0.4704, 0.0293, 0.4704);
			this.tapasextras.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.tapas, () => {
			this.tapasextras.visible = false;
			this.tapas.position.set(0.4704, -0.2229, 0.4704);
			this.tapas.visible = true;
		});
		ObserverEmitter.on(EVENTS.team2.subtopicThree.activityThree.limpiezaKobalto.stepTooltipTwo.portamangas, () => {
			this.tapas.visible = false;
			this.portamangas.position.set(0.4704, -0.6258, 0.4704);
			this.portamangas.visible = true;
		});
	}

	onAnimate(object, previousObject) {
		if (this.animation) {
			this.animation.kill();
		}

		//*regresar el color al anterior
		this.beforeColor = object.material.emissive;
		if (previousObject !== undefined) {
			if (this[previousObject] !== undefined) {
				this[previousObject].material.emissive = this.beforeColor;
			}
		}

		const newMaterial = object.material.clone();
		object.material = newMaterial;

		object.material.emissive.set("#404040");

		this.animation = gsap.to(object.material, {
			emissiveIntensity: 25,
			yoyo: true,
			repeat: -1,
			duration: 0.8,
			ease: "power1.inOut",
		});
	}

	helpers() {
		const gui = new GUI();
		const premiaFolder = gui.addFolder("Tooltip");
		premiaFolder.add(this.position, "x", -20, 20).step(0.0001).name("Posición X");
		premiaFolder.add(this.position, "y", -20, 20).step(0.0001).name("Posición Y");
		premiaFolder.add(this.position, "z", -20, 20).step(0.0001).name("Posición Z");
		premiaFolder.add(this.rotation, "x", -5, 5).step(0.0001).name("rotation X");
		premiaFolder.add(this.rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		premiaFolder.add(this.rotation, "z", -5, 5).step(0.0001).name("rotation Z");
	}

	helpersChild() {
		this.helperMethod("agitadores", this.agitadores);
	}

	helperMethod(name, object) {
		const { position, rotation } = object;
		const gui = new GUI();
		const folferMostrador = gui.addFolder(name);
		folferMostrador.add(position, "x", -20, 20).step(0.0001).name("Posición X");
		folferMostrador.add(position, "y", -20, 20).step(0.0001).name("Posición Y");
		folferMostrador.add(position, "z", -20, 20).step(0.0001).name("Posición Z");
		folferMostrador.add(rotation, "x", -5, 5).step(0.0001).name("rotation X");
		folferMostrador.add(rotation, "y", -5, 5).step(0.0001).name("rotation Y");
		folferMostrador.add(rotation, "z", -5, 5).step(0.0001).name("rotation Z");
		folferMostrador.add(object, "visible").name("Visible");
	}

	renderAnimations() { }
}
